import styled from 'styled-components';
import partnerWithUsBg from '@assets/images/partner_with_us_bg.svg';
import partnerWithUsMobileBg from '@assets/images/partner_with_us_mobile_bg.svg';

export const PartnerWithUsSectionWrapper = styled.div<{
  bgImage?: string;
  width?: string;
}>`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url(${({ bgImage }) => bgImage || partnerWithUsBg}) no-repeat
    center center;
  background-size: cover;
  padding: 12.5rem 0;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    background: url(${partnerWithUsMobileBg}) no-repeat center center;
    background-size: cover;
    padding: 15rem 2rem;
  }
`;

export const Title = styled.h1.attrs<{
  $color?: string;
}>(props => ({
  color: props.$color,
}))`
  color: ${({ $color }) => $color};
  font-size: 8rem;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 115%;
  text-align: center;
  max-width: 102.4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    max-width: 100%;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 5rem;
    text-align: center;
    padding: 0 3rem;
  }
`;

export const SubTitle = styled.h2.attrs<{
  $color?: string;
}>(props => ({
  color: props.$color,
}))`
  color: ${({ $color }) => $color};
  font-size: 4rem;
  font-weight: 300;
  line-height: 115%;
  text-transform: uppercase;
  text-align: center;
  max-width: 102.4rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    max-width: 100%;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: 2rem;
  }
`;
